import authenticationRoutes from "./modules/authentication/routes";
import App from "./App";
import campaignRoutes from "./modules/campaigns/routes";

let routes = [
    // {path: '/', component: App},
];
routes = routes.concat(authenticationRoutes);
routes = routes.concat(campaignRoutes);
export default routes;